import { Component, Input, OnInit, input } from '@angular/core';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.scss',
    imports: [NzGridModule, DatePipe]
})
export class SidebarComponent implements OnInit {
	@Input() sidebar: any;
	readonly settings = input<any>();

	public isSkillSetSummaryView: boolean;
	public isAgeView: boolean;
	public isBirthdateView: boolean;
	public isLocationView: boolean;
	public isMaritalStatusView: boolean;
	public isCurrentRoleView: boolean;
	public isAvailabilityView: boolean;
	public isYearsExpView: boolean;
	public isYearsBPOView: boolean;
	public isLinksView: boolean;
	public isFirefox: boolean;
	public sidebarHeight: any;

	ngOnInit(): void {
		this.isSkillSetSummaryView = this.settings()
			?.filter((e: any) => e.name == 'Summary of Skill Set')
			.map((e: any) => e.active)[0];
		const settings = this.settings();
  this.isAgeView = settings
			?.filter((e: any) => e.name == 'Age')
			.map((e: any) => e.active)[0];
		this.isBirthdateView = settings
			?.filter((e: any) => e.name == 'Birthdate')
			.map((e: any) => e.active)[0];
		this.isLocationView = settings
			?.filter((e: any) => e.name == 'Location')
			.map((e: any) => e.active)[0];
		this.isMaritalStatusView = settings
			?.filter((e: any) => e.name == 'Marital Status')
			.map((e: any) => e.active)[0];
		this.isCurrentRoleView = settings
			?.filter((e: any) => e.name == 'Current Role')
			.map((e: any) => e.active)[0];
		this.isAvailabilityView = settings
			?.filter((e: any) => e.name == 'Availability')
			.map((e: any) => e.active)[0];
		this.isYearsExpView = settings
			?.filter((e: any) => e.name == 'Years of Professional Experience')
			.map((e: any) => e.active)[0];
		this.isYearsBPOView = settings
			?.filter((e: any) => e.name == 'Years of BPO Experience')
			.map((e: any) => e.active)[0];
		this.isLinksView = settings
			?.filter((e: any) => e.name == 'Links')
			.map((e: any) => e.active)[0];

		this.isFirefox = window.navigator.userAgent.includes('Firefox');
	}

	ngAfterViewInit() {
		const divElement = document.querySelector('.sidebar-header') as HTMLElement;
		this.sidebarHeight = `calc(90vh - ${
			divElement == null ? 0 : divElement.offsetHeight
		}px)`;
	}

	calculateAge(birthdate: string): number {
		const birthDate = new Date(birthdate);
		const today = new Date();
		let age = today.getFullYear() - birthDate.getFullYear();
		const monthDiff = today.getMonth() - birthDate.getMonth();

		if (
			monthDiff < 0 ||
			(monthDiff === 0 && today.getDate() < birthDate.getDate())
		) {
			age--;
		}

		return age;
	}
}
